import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 获取收货地址
export function address(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/address`,
    method: 'get',
    params
  })
}
// 获取省市区
export function addressList() {
  return axios.request({
    url: `${urlObj.crm}crm/resarea/gateway/area`,
    method: 'get'
  })
}

// 保存
export function addressPost(data) {
  return axios.request({
    url: `${urlObj.wss}wss-order/address/info`,
    method: 'post',
    data
  })
}

// 删除
export function Deladdress(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/address`,
    method: 'DELETE',
    params
  })
}
